import { atom } from "jotai";

import { BookingWizard } from "../../../types";
import { BookingWizardDataAtom } from "../../stores";

export const setTransportationTypeIdAtom = atom(
  null,
  (get, set, transportationTypeId: string) => {
    const bookingWizardData = get(BookingWizardDataAtom);
    if (!bookingWizardData) {
      return;
    }

    if (bookingWizardData.type === "GolfBooking") {
      const newBookingWizardData: BookingWizard.BookingWizardData = {
        ...bookingWizardData,
        transportationTypeId,
        rounds: bookingWizardData.rounds.map((round) => {
          const hasPlayerSpecificTransportation =
            !round.isOwner &&
            bookingWizardData.transportationTypeId !== null &&
            round.transportationType !== null &&
            round.transportationType.id !==
              bookingWizardData.transportationTypeId;

          if (hasPlayerSpecificTransportation) {
            return round;
          }

          return {
            ...round,
            transportationType: { id: transportationTypeId },
          };
        }),
      };
      set(BookingWizardDataAtom, newBookingWizardData);
    }
  }
);
